import React from "react";
import { SIDE_MENU_WIDTH } from "../SideMenu/SideMenu";

interface Props {
	leftMargin?: number;
	children: React.ReactNode;
	transparent?: boolean;
}

const FloatingButtonPanel: React.FC<Props> = ({
	children,
	leftMargin = SIDE_MENU_WIDTH,
	transparent = true,
}) => {
	return (
		<div
			className={`fixed bottom-0 z-50 flex flex-col items-center justify-center p-4 pointer-events-none 2xl:p-6 [&>*]:pointer-events-auto ${
				!transparent ? "bg-white shadow-lg" : ""
			}`}
			style={{
				left: `${leftMargin}px`,
				width: `calc(100% - ${leftMargin}px)`,
			}}
		>
			{children}
		</div>
	);
};

export default FloatingButtonPanel;
